"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadInput = void 0;
const React = require("react");
const ImgUploader_1 = require("../../atoms/ImgUploader");
/**
 * An image upload input that can be used in forms

 * @see the `ImgUploader` and `FileUploader` atoms for more information
 */
const ImageUploadInput = (_a) => {
    var { metadata = {} } = _a, props = __rest(_a, ["metadata"]);
    return (React.createElement(ImgUploader_1.ImgUploader, Object.assign({}, props, { onChange: (images) => {
            // attach the metadata if provided
            const withMetadata = images.map(img => (Object.assign(Object.assign({}, metadata), img)));
            props.onInputChange(withMetadata);
        }, existingImages: props.value || [] })));
};
exports.ImageUploadInput = ImageUploadInput;
//# sourceMappingURL=index.js.map